import { ParentTypes } from '@risksmart-app/domain/src/types/consts';
import i18n from '@risksmart-app/i18n/src/i18n';
import { t } from 'i18next';

import { getAuditColumns } from './shared';
import type { SharedDataset } from './types';

export const getEntities = () =>
  ({
    hasAccess: (isModuleEnabled, isFeatureFlagEnabled) =>
      isFeatureFlagEnabled('cds_enterprise_risk') &&
      isModuleEnabled('enterprise_risk'),
    objectType: ParentTypes.Entity,
    label: i18n.format(t('entity_other'), 'capitalize'),
    datasetRelationshipOverrides: {
      entities: ['parent', 'child'],
    },
    fields: {
      id: {
        dataType: 'guid',
        displayType: 'text',
        defaultLabel: t('columns.guid'),
      },
      name: {
        dataType: 'text',
        displayType: 'text',
        defaultLabel: t('entity.columns.name'),
      },
      description: {
        dataType: 'text',
        displayType: 'text',
        defaultLabel: t('entity.columns.description'),
      },
      weight: {
        dataType: 'number',
        displayType: 'number',
        defaultLabel: t('entity.columns.weight'),
      },
      ...getAuditColumns(),
    },
  }) as const satisfies SharedDataset;
